export const GET_STATISTICS = 'GET_STATISTICS';
export const GET_STATISTICS_SUCCESS = 'GET_STATISTICS_SUCCESS';
export const GET_STATISTICS_FAIL = 'GET_STATISTICS_FAIL';

export const RESET_STATISTICS_ERRORS = 'RESET_STATISTICS_ERRORS';
